import React, {useEffect, useState} from 'react';
import AppRolesService from "../../General/services/AppRolesService";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import {ColumnDataType, DataTable, Spinner} from "@tag/tag-components-react-v4";
import OrganisationService from "../../ACPP/services/OrganisationService";
import LogsService from "../services/LogsService";

function SignInLogs() {
    const [loading, setLoading] = useState<boolean>(true);
    const [signInLogs, setSignInLogs] = useState<any>(true);

    useEffect(() => {
        loadSignInLogs();
    }, []);

    const columns = React.useMemo(
        () => [
            { accessorKey: 'createdDateTime', header: 'Time', meta: { dataType: 'datetime' as ColumnDataType } },
            { accessorKey: 'id', header: 'Request ID' },
            { accessorKey: 'userDisplayName', header: 'User' },
            { accessorKey: 'conditionalAccessStatus', header: 'Status' }
        ],
        []
    );

    const loadSignInLogs = async () => {
        setLoading(true);

        const signInLogs = await LogsService.getSignInLogs();
        setSignInLogs(signInLogs.value);

        setLoading(false);
    }

    const { accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    let isAdmin = AppRolesService.isUserAdmin(accounts, isAuthenticated);

    let content;
    content = <>
        <h1>Sign In Logs</h1>
        <h4>Ten days worth of sign in logs, an entry is generated when the user requests a new bearer token</h4>
        <DataTable
            isLoading={loading}
            loadingElement={
                <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                    <Spinner>Waiting for data...</Spinner>
                </div>
            }
            columns={columns}
            data={signInLogs}
        />
    </>

    return (
        <>
            {content}
        </>
    )

}

export default SignInLogs;
